import React from "react";
import { AlertDialog, AlertDialogControl, AlertDialogProps } from ".";

type HookReturnType = {
  alertDialogCtrl: {
    open: (props: AlertDialogProps) => void;
    close: Function;
  };
  alertDialogComponent: JSX.Element;
};

export function useAlertDialog(): HookReturnType {
  const [dialogProps, setDialogProps] = React.useState<AlertDialogProps>({});
  const dialogControl = React.useRef<AlertDialogControl | null>(null);
  const alertDialogComponent = React.useMemo(
    () => <AlertDialog {...dialogProps} ref={dialogControl} />,
    [dialogProps]
  );

  const alertDialogCtrl: HookReturnType["alertDialogCtrl"] = React.useMemo(
    () => ({
      open: (props) => {
        setDialogProps(props);
        dialogControl.current?.open();
      },
      close: () => dialogControl.current?.close(),
    }),
    []
  );

  return {
    alertDialogCtrl,
    alertDialogComponent,
  };
}
